enum PointErrorCodes {
    ALREADY_CREATED = "ALREADY_CREATED",
    NOT_FOUND = "NOT_FOUND",
}

export default PointErrorCodes;
